import React from 'react';
import PropTypes from 'prop-types';
import '../assets/css/components/module-content-card.css';

const ModuleContentCard = ({ content, handleClick }) => (
  <div onClick={handleClick} className="col-md-6 col-lg-4 col-xl-3 m-b-10 module-content-card">
    <div className='ar-1-1'>
      <div className={`card no-border ${content.type.replace('ngss-','')} widget widget-loader-circle-lg no-margin`}>
        <div className="card-block">
          <div className="pull-bottom bottom-left bottom-right">
            <br/>
            <p className="content-name text-white">{content.name || content.title}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const { object, func } = PropTypes
ModuleContentCard.propTypes = {
  content:        object.isRequired,
  handleClick:  func.isRequired
}

export default ModuleContentCard;
